module.exports = __webpack_public_path__ + "static/media/share_button_twitter.42cb5f74.svg";